'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Row2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Row.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Row.js
 ** module chunks = 0
 **/